export default __webpack_public_path__ + "static/media/01_whale.919d3d1b.webp";